import { Input } from 'antd';
import React, { useCallback } from 'react';
import useChatCore from '../../hooks/useChatCore.js';
import { useAIChat } from '../../hooks/useAIChat.jsx';
import { ReactComponent as SendSvg } from '../../assets/svgs/send.svg';
import SvgCom from '../SvgCom/index.jsx';
import ChatMainBody from './components/ChatMainBody.jsx';
import { LoadingOutlined } from '@ant-design/icons';

const AIChatCom = () => {
  const { loading, } = useAIChat();
  const { quesText,  inputValChange, onSend } = useChatCore();

  const fnKeyDown = useCallback((e) => {
    if(loading) return;
    if (e.key === 'Enter') {
      onSend();
    }
  }, [loading, onSend]);

  return <div className='flex flex-col w-full h-full p-5 bg-grey-1 rounded-[9px]'>
    <div className="flex-1 overflow-x-hidden overflow-y-auto mb-3" id="customer_ai_chat">
      <ChatMainBody></ChatMainBody>
    </div>
    <div className='flex items-center rounded-[20px] bg-white px-[5px] py-[5px]'>
      <Input onKeyDown={fnKeyDown} disabled={loading} value={quesText} onChange={inputValChange} className='flex-1 h-[42px] border-none text-primary text-[16px] leading-none px-2 !shadow-none' placeholder="Enter what you want to ask"></Input>
      <div onClick={() => !loading && onSend() } className='w-[42px] h-[42px] rounded-full flex items-center justify-center bg-primary ml-2 cursor-pointer'>
        {
          loading ? <LoadingOutlined className="w-4 h-4 text-white"></LoadingOutlined> : <SvgCom Svg={SendSvg} size='16'></SvgCom>
        }
      </div>
    </div>
  </div>;
};

export default AIChatCom;